export default __webpack_public_path__ + "static/media/1611.1fd019b2.png";